import { useNavigate } from "react-router-dom";
import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { useBulkTemplatePermissions } from "byzantine/src/dbbl/businessLogic/modules/bulkTemplates";
import { SearchBar } from "../../PaymentActivity/common";
import FilterContainer from "../../PaymentActivity/Filters/FilterContainer";
import { FilterChips } from "../../PaymentActivity/Filters/filterConfig";
import { TEMPLATES_ROUTE } from "../constants";
import useBulkTemplatesContainer from "./useBulkTemplatesContainer";
import BulkTemplatesTable from "./BulkTemplatesTable";
import styles from "../Templates.module.scss";

const BulkTemplatesContainer = () => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  const permissions = useBulkTemplatePermissions();

  const {
    state,
    templates,
    loading,
    pagination,
    isFiltered,
    sortDirection,
    handleSearchChange,
    handleSetFilters,
    handleToggleSort,
    refetchCurrentPage,
  } = useBulkTemplatesContainer();

  return (
    <div>
      <div className="margin--top--xl">
        <SearchBar
          handleSearchChange={handleSearchChange}
          searchValue={state.searchValue}
          placeholder={l10n.getString("search-ach-templates-label")}
        />
      </div>
      <div className={styles.filterRow}>
        <FilterContainer
          setFilters={handleSetFilters}
          filters={state.filters}
          allowedFilters={[FilterChips.TEMPLATE_STATUS, FilterChips.ACCOUNT]}
          parentSelectableFilters={[
            FilterChips.TEMPLATE_STATUS,
            FilterChips.ACCOUNT,
          ]}
        />
        {permissions.canEdit && (
          <Button
            kind="plain"
            startIcon="plus"
            onClick={() => navigate(`/${TEMPLATES_ROUTE}/ach/new`)}
            label={l10n.getString("new-template")}
            style={{ whiteSpace: "nowrap" }}
          />
        )}
      </div>
      <BulkTemplatesTable
        templates={templates}
        loading={loading}
        isFiltered={isFiltered}
        pagination={pagination}
        sortDirection={sortDirection}
        onToggleSort={handleToggleSort}
        refetchCurrentPage={refetchCurrentPage}
      />
    </div>
  );
};

export default BulkTemplatesContainer;
